module.exports = __webpack_public_path__ + "static/media/22ESCWA15.5d16af74.jpg";